import { useRef } from 'react';
import { createTransport, createXResolveProvider, Transport } from '@spotify-internal/transport';

import auth from '../../lib/shared/auth/auth';

export const useTransport = () => {
  const transportRef = useRef<Transport>();

  // Initialize synchronously on first render to prevent race condition
  // where ExperimentationProvider renders children without RemoteConfig context
  if (!transportRef.current) {
    transportRef.current = createTransport({
      providers: {
        endpoints: createXResolveProvider(),
        token: () => auth.tokenProvider(),
      },
    });
  }

  return transportRef.current;
};
